<template>
  <div class="bg-secondary-3 p-2">
    <div class="bg-white rounded p-3">
      <div class="pt-2">
        <em class="fas fa-clock text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Estatus
        </span>
      </div>

      <custom-result-not-found
        v-if="!history.length"
        class="mt-4 row pt-3"
        text="No hay Información Disponible."
      />

      <time-line v-else class="mt-4">
        <div v-for="(historyItem, index) in history" :key="index">
          <time-line-item class="custom-time-line rounded">
            <template #date>
              <div class="date-container">
                <div class="color-black font-16 font-weight-bold fulldate">
                  {{ historyItem.date | date }}
                </div>
                <div class="color-black font-12 font-weight-bold hour">
                  {{ historyItem.date | hour }}
                </div>
              </div>
            </template>

            <div class="row mx-1">
              <div class="col col-md-3">
                <custom-balloon
                  class="d-lc-inline"
                  :text="historyItem.statusName"
                  :background-color="getColor(historyItem.statusId)"
                />
              </div>
              <div class="col col-md-9">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Cambiado por:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ historyItem.userName | empty }}
                </div>
              </div>
              
              <div class="col col-md-3"></div>
              <div
                v-if="historyItem.statusId == statusEnum.denied"
                class="col col-md-9"
              >
                <div class="bg-white rounded p-3 mt-3">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Comentario:
                  </div>
                  <div>
                    {{ historyItem.deniedComment }}
                  </div>
                </div>
              </div>
            </div>
          </time-line-item>
        </div>
      </time-line>

      <div class="d-flex justify-content-end mt-4">
        <action-button
          variant="danger mr-2"
          i="fas fa-times-circle"
          text="Cerrar"
          @click="$emit('hide')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { CustomResult } from '@/components/common/FilterCustomManager';
import { Colors } from '../../common';
import statusEnum from '@/utils/constants/student/childCountStatusEnum';
import { ActionButton } from '@/components/common';
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import CustomResultNotFound from "custom-result-not-found";
import CustomBalloon from "@/components/common/CustomBalloon.vue";

export default {
  name: 'StatusTimeLine',
  components: {
    CustomResult,
    ActionButton,
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    CustomResultNotFound
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      statusEnum: statusEnum,
    };
  },
  methods: {
    getColor: (status) => {
      let color = '';
      switch (status) {
        case statusEnum.new:
        color = Colors.GRAY;
        break;
        case statusEnum.approved:
          color = Colors.GREEN;
          break;
        case statusEnum.submited:
          color = Colors.YELLOW;
          break;
        case statusEnum.denied:
          color = Colors.BROWN;
          break;
      }
      return color;
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

:deep(.w-date-fixed) {
  width: 120px !important;
}
</style>
